import { render, staticRenderFns } from "./ScoutFormAge.vue?vue&type=template&id=623e6e33"
import script from "./ScoutFormAge.vue?vue&type=script&lang=js"
export * from "./ScoutFormAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports